import "./footer.scss";

const Footer: React.FC = () => {
    return (
        <footer>
            <div className="footer-content contain">
                <div className="footer-address">
                    <div className="footer-wrapper">
                        <h3 className="bray">7 Down Street</h3>
                        <div className="flexbox">
                            <p>
                                Mayfair <br />
                                London W1J 7AN
                            </p>
                            <p>
                                12,307 sq ft <br />
                                Available Now
                            </p>
                        </div>
                    </div>
                    <div className="agents-wrapper">
                        <div className="footer-wrapper agents">
                            <img src="/images/bray.svg" className="bray" alt="Bray Fox Smith" />
                            <div className="flexbox">
                                <div className="agent">
                                    <h3>Rob Skioldebrand</h3>
                                    <a href="mailto:robertskioldebrand@brayfoxsmith.com">
                                        <p>Email</p>
                                    </a>
                                    <a href="tel:07769725412">
                                        <p>07769 725 412</p>
                                    </a>
                                </div>
                                <div className="agent">
                                    <h3>Harry Bray-Smith</h3>
                                    <a href="mailto:harrybraysmith@brayfoxsmith.com">
                                        <p>Email</p>
                                    </a>
                                    <a href="tel:07345600278">
                                        <p>07345 600 278</p>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="footer-wrapper agents">
                            <div className="bray">
                                <img src="/images/lawson.svg" alt="Lawson and Partners" />
                            </div>
                            <div className="flexbox">
                                <div className="agent">
                                    <h3>Richard Clayton</h3>                                    
                                    <a href="mailto:richard@lawsonandpartners.com">
                                        <p>Email</p>
                                    </a>
                                    <a href="tel:07500787306">
                                        <p>07500 787 306</p>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer-disc">
                    <p>© Copyright 7 Down Street. 2025. | A website by <a href="https://www.mattersoho.co.uk/" target="_blank" rel="noopener noreferrer">Matter</a>.</p>
                    <p>Disclaimer</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
